<template>
  <router-link
    :to="to"
    :title="title"
    :class="`btn quick-link custom-pointer btn-radius ${
      btnName != '' ? '' : 'akkurate-small'
    } ${classes}`"
    style="text-decoration: none"
  >
    <font-awesome-icon
      class="ms-2 .quick-link-icon"
      v-if="icon != ''"
      size="xl"
      :icon="['fas', icon]"
    />

    <span class="mt-3">
      {{ btnName }}

      <font-awesome-icon
        class="ms-2 .quick-link-icon"
        v-if="icon != ''"
        size="sm"
        :icon="['fas', 'arrow-right']"
      />
    </span>
  </router-link>
</template>

<script>
export default {
  name: "QuickLink",
  props: {
    to: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: "",
      required: false,
    },
    btnName: {
      type: String,
      default: "",
      required: false,
    },
    icon: {
      type: String,
      default: "",
      required: false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
  },
};
</script>
